export const autoplayCarouselSlidesPerView = {
  mobile: 2,
  tablet: 3,
  desktop: 3,
}
